import React from "react";
import { FilterInfoContainer } from "./common";

export const CategoryFilterInfoSection = ({ searchResultInfo }) => {
  const { filterCondition, totalCount } = searchResultInfo;
  return (
    <FilterInfoContainer condition={filterCondition} totalCount={totalCount} />
  );
};
